export const RadnoVrijemeEvdResourceBS: RadnoVrijemeEvdInterface = {
  title: "Evidencija radnog vremena",
  nextButton: "Save evidencije",
  description:
    "Molimo odaberite period u kojem se nalaze evidencije radnog vremena.",
  inputFields: {
    endDate: {
      label: "Krajnji datum",
    },
    startDate: {
      label: "Pocetni datum",
    },
    entryType: {
      error: "Molimo odaberite tip evidencije radnog vremena.",
      label: "Tip evidencije radnog vremena",
      name: "entryType",
      placeholder: "Odaberite tip evidencije radnog vremena",
    },
    napomena: {
      error: "Molimo unesite napomenu.",
      label: "Napomena",
      name: "napomena",
      placeholder: "Po potrebi unesite napomenu",
    },
    pocetak: {
      error: "Molimo unesite pocetak radnog vremena.",
      label: "Pocetak radnog vremena",
      name: "pocetak",
      placeholder: "Molimo unesite pocetak radnog vremena",
    },
    zavrsetak: {
      error: "Molimo unesite zavrsetak radnog vremena.",
      label: "Zavrsetak radnog vremena",
      name: "zavrsetak",
      placeholder: "Molimo unesite zavrsetak radnog vremena",
    },
    pocetakPauze: {
      error: "Molimo unesite pocetak pauze.",
      label: "Pocetak pauze",
      name: "pocetakPauze",
      placeholder: "Molimo unesite pocetak pauze",
    },
    zavrsetakPauze: {
      error: "Molimo unesite zavrsetak pauze.",
      label: "Zavrsetak pauze",
      name: "zavrsetakPauze",
      placeholder: "Molimo unesite zavrsetak pauze",
    },
  },
  errors: {
    errorDeleting:
      "Doslo je do greske tokom brisanja evidencije radnog vremena. Molimo kontaktirajte administratora.",
    errorLoading:
      "Doslo je do greske tokom loadiranja evidencije radnog vremena. Molimo kontaktirajte administratora.",
    errorUpdating:
      "Doslo je do greske tokom spasavanja evidencije radnog vremena. Molimo kontaktirajte administratora.",
    errorMissingFields:
      "Molimo popunite obavezna polja - tip radnog vremena, pocetak radnog vremena i zavrsetak radnog vremena.",
    errorPeriodLocked:
      "Period za odabrani datum je zaključan. Izmjene nisu dozvoljene dok menadžer ne otvori period ponovo.",
    errorDuplicateEntry:
      "Već postoji unos sa istim tipom i vremenom za ovaj dan. Promijenite tip ili satnicu.",
  },
  types: {
    placeholder: "Molimo odaberite tip radnog vremena",
    radnovrijeme: "Radno vrijeme",
    dezura: "Dezura",
    odsustvo: "Odsustvo",
    bolovanje: "Bolovanje",
    slobodandan: "Slobodan dan",
    pripravnost: "Pripravnost",
    radusmjenama: "Rad u smjenama",
    terenskirad: "Terenski rad",
  },
  successModal: {
    title: "Uspješno dodano u bazu",
    body: "Unos radnog vremena je uspješno sačuvan. Možete nastaviti sa izmjenama ili ažuriranjem.",
    buttonOk: "U redu",
  },
};

interface InputFieldInterface {
  label: string;
  name: string;
  placeholder: string;
  error: string;
}

interface SuccessModal {
  title: string;
  body: string;
  buttonOk: string;
}

export interface RadnoVrijemeEvdInterface {
  successModal: SuccessModal;
  title: string;
  description: string;
  nextButton: string;
  inputFields: {
    startDate: {
      label: string;
    };
    endDate: {
      label: string;
    };
    entryType: InputFieldInterface;
    pocetak: InputFieldInterface;
    zavrsetak: InputFieldInterface;
    napomena: InputFieldInterface;
    pocetakPauze: InputFieldInterface;
    zavrsetakPauze: InputFieldInterface;
  };
  errors: {
    errorLoading: string;
    errorUpdating: string;
    errorDeleting: string;
    errorMissingFields: string;
    errorPeriodLocked: string;
    errorDuplicateEntry: string;
  };
  types: {
    placeholder: string;
    radnovrijeme: string;
    dezura: string;
    odsustvo: string;
    bolovanje: string;
    slobodandan: string;
    pripravnost: string;
    radusmjenama: string;
    terenskirad: string;
  };
}
